// 是否本地环境
export const isLocal =
  window.location.hostname.indexOf('dev.jd.com') !== -1 ||
  window.location.hostname.indexOf('localhost.jd.com') !== -1 ||
  window.location.hostname.indexOf('dev.jdtest.net') !== -1;

/**
 * @zero/mc-utils包中，
 * IS_DEV对应的jdtest.net域名，表示测试环境
 * IS_TEST对应的test-newseckill.jd.com域名，表示预发环境 - 历史原因，这边记一下
 */

// 本地测试环境
export const isLocalJDTest = window.location.hostname.indexOf('dev.jdtest.net') !== -1;
